module.exports = __webpack_public_path__ + "static/media/bricklayer.ba47aa8e.jpg";